import {createReducer} from '@reduxjs/toolkit'

export const owner = createReducer(false, () => {})
